import { ReactNode } from 'react';

import { useLocalStorage, useToken } from '@hsp/react-hooks';
import { ACCESS_TOKEN, coerceBoolean, IAuthenticationToken, isDefined, isNotEmpty } from '@hsp/utilities';

import { useAppSelector } from '@h/store';

import { selectEmail } from '@s/selectors';

import { SignalRContext } from 'context/signalr';
import { SignalRProps } from 'types/components/signalr';

export const useSignalRConfiguration = ({ children, uri }: SignalRProps) => {
  const email = useAppSelector(selectEmail);

  const [accessToken] = useLocalStorage<IAuthenticationToken>(ACCESS_TOKEN, null);
  const { isExpired } = useToken(accessToken);

  const isSignalREnabled = coerceBoolean(process.env.REACT_APP_USE_SIGNAL_R, false);

  let component: ReactNode | null = <></>;

  if (isDefined(uri) && isNotEmpty(uri)) {
    component = (
      <SignalRContext.Provider
        accessTokenFactory={() => accessToken?.token ?? ''}
        automaticReconnect
        connectEnabled={!isExpired && isSignalREnabled && isDefined(email) && isNotEmpty(email)}
        dependencies={[accessToken?.token, isExpired, isSignalREnabled, email]}
        headers={{ token: accessToken?.token ?? '', 'user-id': email ?? '' }}
        url={uri}>
        {children}
      </SignalRContext.Provider>
    );
  }

  return { component };
};
